import { TFunction } from "react-i18next";
import * as yup from "yup";
import { PasswordRecoveryFormValues } from "./interfaces";

export const initialValues: PasswordRecoveryFormValues = {
  email: "",
};

export const getValidationSchema = (
  t: TFunction
): yup.SchemaOf<PasswordRecoveryFormValues> =>
  yup.object().shape({
    email: yup
      .string()
      .email(t("7894") /* O campo deverá ser válido */)
      .required(t("7893") /* O campo deverá ser preenchido */),
  });
